import { Api } from "../api/Api";

const state = {
  categories: []
};

const mutations = {
  UPDATE_CATEGORIES(state, payload) {
    state.categories = payload;
  }
};

const actions = {
  async listCategories({ commit, dispatch }) {
    try {
      dispatch("isListLoading", true, { root: true });
      const response = await Api().get("/cards-management/categories");

      if (response) {
        commit("UPDATE_CATEGORIES", response.data);
      }
    } catch (e) {
      dispatch(
        "showSnackBar",
        {
          snackbar: true,
          message:
            e?.response?.data?.message ?? "Unable to fetch card categories",
          status: "red"
        },
        { root: true }
      );
    } finally {
      dispatch("isListLoading", false, { root: true });
    }
  },
  async createCategory({ dispatch }, payload) {
    try {
      dispatch("isLoading", true, { root: true });
      const response = await Api().post(
        "/cards-management/categories",
        payload
      );

      if (response) {
        dispatch("listCategories");
        dispatch(
          "showSnackBar",
          {
            snackbar: true,
            message:
              response?.data?.message ?? "Card category created successfully",
            status: "success"
          },
          { root: true }
        );
      }
    } catch (e) {
      dispatch(
        "showSnackBar",
        {
          snackbar: true,
          message:
            e?.response?.data?.message ?? "Unable to create card category",
          status: "red"
        },
        { root: true }
      );
      throw e;
    } finally {
      dispatch("isLoading", false, { root: true });
    }
  },
  async updateCategory({ dispatch }, payload) {
    try {
      dispatch("isLoading", true, { root: true });
      const { id, ...data } = payload;
      const response = await Api().put(
        `/cards-management/categories/${id}`,
        data
      );

      if (response) {
        dispatch("listCategories");
        dispatch(
          "showSnackBar",
          {
            snackbar: true,
            message:
              response?.data?.message ?? "Card category updated successfully",
            status: "success"
          },
          { root: true }
        );
      }
    } catch (e) {
      dispatch(
        "showSnackBar",
        {
          snackbar: true,
          message:
            e?.response?.data?.message ?? "Unable to update card category",
          status: "red"
        },
        { root: true }
      );
      throw e;
    } finally {
      dispatch("isLoading", false, { root: true });
    }
  }
};

const getters = {
  getCardCategories: state => state.categories
};

export const cards = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
